export const NAVBAR_BLOCK_s5 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#0F0F0F"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "🌤 Lumic",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "Features",
      "linkUrl": "/features",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Services",
      "linkUrl": "/services",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Docs",
      "linkUrl": "/docs",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Join Waitlist",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "#ffffff",
        "border-width": "0px",
        "border-radius": "0.75rem",
        "padding": "14px 30px 14px 30px",
        "margin": "0px 0px 0px 120px",
        "border-color": "#4f4f4f",
        "background-color": "#693DEF"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#ffffff",
    "border-color": "#ffffff"
  },
  "metaDataId": 1746275634508,
  "afterIndex": 2,
  "blockId": 1746275634508,
  "linksStyleProps": {
    "color": "#bfbfbf",
    "padding": "14px 0px 14px 0px",
    "font-weight": "600"
  }
}